import { Component, OnInit, OnDestroy } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { ContextService } from '../../../shared/services/context-service/context.service';
import { LoaderModel } from '../../../shared/personne.state';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  standalone: false
})
export class LoadingComponent implements OnInit, OnDestroy {
  @Select(state => state.personne.loader)
  isLoading$: Observable<LoaderModel>;
  isLoadingSubscription: Subscription;

  type: string;
  isLoading = true;

  constructor(private readonly _contextService: ContextService) {}

  ngOnInit() {
    this.isLoadingSubscription = this.isLoading$.subscribe(data => {
      this.type = data.type;
      this.isLoading = this.type !== null;
    });
  }

  ngOnDestroy(): void {
    if (this.isLoadingSubscription) {
      this.isLoadingSubscription.unsubscribe();
    }
  }

  get isDsdContext() {
    return this._contextService.isDsdContext;
  }
}
